import { pgEnum } from 'drizzle-orm/pg-core';

export const invoice_status = pgEnum('invoice_status', [
  'DRAFT',
  'OPEN',
  'PAID',
  'VOID',
  'UNCOLLECTIBLE',
]);

export const auto_pay_status = pgEnum('auto_pay_status', [
  'SCHEDULED',
  'PROCESSING',
  'SUCCEEDED',
  'FAILED',
  'CANCELLED',
]);

/**
 * Autopay scheduling mode:
 * - DAYS_AFTER_INVOICE: Schedule autopay X days after invoice date (traditional mode)
 * - DAY_OF_MONTH: Schedule autopay on a specific day of each month (e.g., always on the 15th)
 */
export const auto_pay_mode = pgEnum('auto_pay_mode', [
  'DAYS_AFTER_INVOICE',
  'DAY_OF_MONTH',
]);

/**
 * Controls which dump ticket artifact is auto-attached to invoices:
 * - NONE: No automatic attachment (default)
 * - DRIVER_PHOTO: Attach the raw photo taken by the driver at the dump site
 * - GENERATED_TICKET: Attach the TrashLab-generated dump ticket PDF
 */
export const dump_ticket_invoice_attachment_mode = pgEnum(
  'dump_ticket_invoice_attachment_mode',
  ['NONE', 'DRIVER_PHOTO', 'GENERATED_TICKET'],
);
